
var Artist = (function () {

  var $container;

    // Metodes publics
    var init = function() {
      $container = $('.related .row');
      makeIsotope();
    };

    function makeIsotope() {
       $container.imagesLoaded( function() {
           $container.isotope({
              itemSelector: '.item',
              layoutMode: 'masonry'
            });
        });
    }

    return {
      init: init,
      container: $container
    };

  }());


var ArtistDirectory = (function () {

    var ajaxActive = false;

    // Metodes publics
    var init = function() {
        bindEvents();
        getArtistesAjax();
    };

    // Metodes privats
    function bindEvents() {
        $(document).on('click', '.lletra', function(e){
            e.preventDefault();
            getArtistesAjax($(this).data('lletra'));
        });
    }


    function getArtistesAjax(lletraClick) {
        var lletra = lletraClick || null;

        if(!ajaxActive) {
            ajaxActive = true;

            $('#ajax-loader').show();
            $('.filter-items').addClass("blur");

            $.ajax({
                type: "GET",
                url: "/auxiliar/artists.php",
                data: {
                    lletra: lletra
                }
            })
            .done(function( contentHtml ) {
                $('.filter-items').html(contentHtml);
                $('#ajax-loader').hide();
                $('.filter-items').removeClass("blur");

                ajaxActive = false;
            });
        }
    }



    return {
        init: init
    };

}());

var Browse = (function () {

  var currentPage = 1;
  var ajaxActive = false;
  var $container;
  var end = false;


    // Metodes publics
    var init = function() {
      $container = $('.product-list .row');

      bindEvents();
      makeIsotope();
      getProductesAjax();
    };

    // Metodes privats
    function bindEvents() {
      $(window).scroll(function(){

        var footer = parseInt($('.bottom-menu').css('margin-top'), 10) + $('.bottom-menu').outerHeight() + 100;

        if($(window).scrollTop() + footer >= $(document).height() - $(window).height()){
          getProductesAjax();
        }
      });

        $(document).on('change', 'select[name="category"],select[name="price"],select[name="size"]', function(){
          end = false;
          resetColumnes();
          getProductesAjax();
        });
      }


      function getProductesAjax() {
         if(!ajaxActive && !end) {
          ajaxActive = true;

          $('#ajax-loader').show();

          $.ajax({
            type: "GET",
            url: "/auxiliar/browse.php",
            data: {
              page: currentPage,
              limit: 20,
              categoria: $('select[name="category"]').val(),
              price: $('select[name="price"]').val(),
              size: $('select[name="size"]').val()
            }
          })
          .done(function( html ) {
            $('#ajax-loader').hide();
            if(html=="KO"){
                end = true;
            }else{
              $container.isotope('insert',$(html));
              $container.imagesLoaded( function() {
                $container.isotope('layout');
                General.checkLargeImages();
              });
              activateWishlist();
              currentPage += 1;
            }
            ajaxActive = false;

          });
        }
      }

      function makeIsotope() {
        //$container.imagesLoaded( function() {
           $container.isotope({
              itemSelector: '.item',
              layoutMode: 'masonry'
            });
        //});
      }

      function resetColumnes() {
        var elToRemove = $container.children();
        $container.isotope('remove',elToRemove);

        currentPage = 1;
      }


      return {
        init: init,
        container: $container
      };

    }());

/**
* Carro de compra
*/


(function(){

    // Mostrar / ocultar carro lateral
    $(document).on('click', '.cart-trigger', function(event){
        event.preventDefault();
        $('#cart').toggleClass('visible');
        $('#overlay-layer').toggleClass('visible');
        $('body').toggleClass('overflow-hidden');
    });

    $("#form_adr_fact").submit(function(){
        var nif = $('#direccio_facturacio_nif').val();
        var controlGroup = $('#direccio_facturacio_nif').closest('.control-group');
        // Clean errors
        controlGroup.removeClass('has-error');
        controlGroup.find('.help-block').hide();
        // Validar nif
        if (!isNifValid(nif)) {
            $('#direccio_facturacio_nif').focus();
            controlGroup.addClass('has-error');
            controlGroup.find('.help-block').show();
            return false;
        }
        return true;
    });

    function isNifValid(nif) {
        if (nif.length===0) {
            return true;
        }
        // Validar longitud
        if (nif.length<3) {
            return false;
        }
        // Validar si conté un nº o més
        if (!/\d/.test(nif)) {
            return false;
        }
        // Validar si conté una lletra o més
        if (!/[a-zA-Z]/.test(nif)) {
            return false;
        }
        return true;
    }

    /*Submit order*/
    $('#confirm_order').on("submit",function(){
      $('#observacions_final').val($('#observacions').val());
    })

})();


var Category = (function () {

  var currentPage = 2;
  var ajaxActive = false;
  var $container;
  var categoria;
  var limit = 20;
  var end = false;

  // Metodes publics
  var init = function() {
    $container = $('.product-list .row');
    categoria = $('.page-category').data("id");
    bindEvents();
    makeIsotope();
    getProductesAjax();
    activateWishlist();
  };

  // Metodes privats
  function bindEvents() {
    $(window).scroll(function(){

      var footer = parseInt($('.bottom-menu').css('margin-top'), 10) + $('.bottom-menu').outerHeight() + 100;

        if($(window).scrollTop() + footer >= $(document).height() - $(window).height()){
          getProductesAjax();
        }
    });

  }

  function getProductesAjax() {
    if(!ajaxActive && !end) {
      ajaxActive = true;

      $('#ajax-loader').show();

      $.ajax({
        type: "GET",
        url: "/auxiliar/category.php",
        data: {
          page: currentPage,
          limit: limit,
          categoria: categoria
        }
      })
      .done(function( html ) {
        $('#ajax-loader').hide();
        if(html=="KO"){
          end = true;
        }else{
          $container.isotope('insert',$(html));
          $container.imagesLoaded( function() {
            $container.isotope('layout');
          });
          currentPage += 1;
        }
        ajaxActive = false;

        activateWishlist();
      });
    }
  }

  function makeIsotope() {
    $container.imagesLoaded( function() {
       $container.isotope({
          itemSelector: '.item',
          layoutMode: 'masonry'
        });
    });
  }

  return {
    init: init,
    container: $container
  };

}());



var General = (function () {

    function events(){

      $(window).resize(function(){
        checkLargeImages();
      });

    }

    function checkLargeImages(){
        if ($('.cont-img').length>0) {
            var maxh = $('.cont-img').css('max-height').replace(/[^-\d\.]/g, '');
            $('.cont-img img').each(function(){
                if( $(this).height() > maxh ){
                    $(this).parent().find('.overlay').addClass('show');
                }else{
                    $(this).parent().find('.overlay').removeClass('show');
                }
            });
        }
    }



    return {
      checkLargeImages: checkLargeImages,
      events: events
    };

  }());


  $(function () {
      "use strict";
      General.events();
  });

/*

FUNCTION

*/
function mostrarAvisosAjax() {
    $.ajax({
        type: "POST",
        cache: false,
        url: "/avisos/",
    })
    .done(function( msg ) {
        $("#div-avisos").html(msg);

        $("html, body").animate({ scrollTop: 0 }, "normal");
        return false;

        setTimeout(function(){
          $("#div-avisos").html("");
        }, 5000);
    });
}

function refreshCart(callback) {
    $.get("/auxiliar/cart.php", {action: "refresh"}, function( data ) {
        cart = JSON.parse(data);

        html = "";
        for(var i in cart.productes) {
            html += '<li class="cart-item clearfix">';
            html += '<div class="cart-item-caption">';
            html += '<img src="' + cart.productes[i].imatge + '" alt="">';
            html += '</div><div class="cart-item-info">';
            html += '<p>' + cart.productes[i].nom + '</p>';

            html += '<p>' + cart.productes[i].marc + '</p>';

            html += '<span>' + cart.productes[i].preu + '</span>';
            html += '</div><a href="#" data-codi="' + cart.productes[i].codi + '" class="cart-remove-item"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a>';
            html += '</li>';
        }
        if(cart.transport_preu.length>0){
            html += '<li class="cart-item clearfix">';
            html += '<div class="cart-item-caption" style="height: 1px;"></div>';
            html += '<div class="cart-item-info">';
            html += '<p>' + cart.transport_nom + '</p>';
            html += '<span>' + cart.transport_preu + '</span>';
            html += '</div>';
            html += '</li>';
        }

        $('.cart-item-list').html(html);

        $('.cart-subtotal').html('<p>' + cart.subtotal + '</p>');
        $('.cart-tax').html('<p>' + cart.tax_productes + '</p>');
        $('.cart-total').html('<p>' + cart.total + '</p>');

        $('.cart-trigger span').html(cart.numProductes);

        if (typeof callback !== "undefined") {
            callback(cart);
        }

    }, "text");
}



$(document).ready(function() {

    refreshCart();

     // Register
      if($('.login_register').length>0) {
        if(window.location.href.indexOf("register") > -1) {
          $('#register').modal();
        }
      }

      $('.toggleCercador').on('click',function(e){
        e.preventDefault();
        $(this).hide();
        $('.cercador').closest('.form-inline').removeClass("hide");
        $('.cercador').focus();
      });

    $(".form_add_to_cart").submit(function(e){
        e.preventDefault();

        var button = $(this).find("button");
        var boto_loading = button.data("loading");
        var boto_original = button.html();
        button.html(boto_loading);
        button.attr("disabled", "disabled");

        $.ajax({
            type: "POST",
            url: "/auxiliar/cart.php",
            data: {
                action: "add",
                data: {
                    codi: $(this).find('input[name="codi"]').val(),
                    marc_codi: $(this).find('select[name="marc_codi"]').val(),
                    uds: $(this).find('input[name="uds"]').val(),
                    opcio_id: $(this).find('#opcio').val(),
                    import_xec: $(this).find('input[name="custom_import"]').val()
                }
            }
        })
        .done(function( res ) {
            var response = JSON.parse(res);

            if(response.status == "OK") {
                refreshCart(function(){
                    button.html(boto_original);
                    button.removeAttr("disabled");
                    $('#cart').toggleClass('visible');
                    $('#overlay-layer').toggleClass('visible');
                    $('body').toggleClass('overflow-hidden');
                });
            }
            else {
                mostrarAvisosAjax();
                button.html(boto_original);
                button.removeAttr("disabled");
            }
        });
    });

    // Eliminar producte des del carro lateral
    $( document ).on("click", ".cart-remove-item", function(e) {
        e.preventDefault();

        var codi = $(this).data("codi");

        $.ajax({
            type: "POST",
            url: "/auxiliar/cart.php",
            data: {
                action: "delete",
                codi: codi
            }
        })
        .done(function( res ) {
            var response = JSON.parse(res);

            if(response.status == "OK") {
                refreshCart();
            }
        });
    });

    // Eliminar producte des de la pagina de direccions
    $( document ).on("click", ".btn-eliminar-cart", function(e) {
        e.preventDefault();

        var codi = $(this).data("codi");

        $.ajax({
            type: "POST",
            url: "/auxiliar/cart.php",
            data: {
                action: "delete",
                codi: codi
            }
        })
        .done(function( res ) {
            var response = JSON.parse(res);

            if(response.status == "OK") {
                refreshCart(function(){
                    $('#tr-cart-' + codi).remove();
                    $('.total span').html(cart.total + ' €');
                });
            }
        });
    });


    /*
    CART DIRECTION
    */

    $("#cart-direction-form").click(function (e) {
        if($("#dir_igual").is(':checked'))
        {
            $("#direccio_envio").slideUp("slow");
            $('#direccio_envio_empresa').val($('#direccio_facturacio_empresa').val());
            $('#direccio_envio_nom').val($('#direccio_facturacio_nom').val());
            $('#direccio_envio_cognom').val($('#direccio_facturacio_cognom').val());
            $('#direccio_envio_direccio1').val($('#direccio_facturacio_direccio1').val());
            $('#direccio_envio_direccio2').val($('#direccio_facturacio_direccio2').val());
            $('#direccio_envio_cp').val($('#direccio_facturacio_cp').val());
            $('#direccio_envio_ciutat').val($('#direccio_facturacio_ciutat').val());

            var pais = $('#direccio_facturacio_pais option:selected').val();
            $('#direccio_envio_pais option[value='+pais+']').attr("selected", "selected");

            $('#direccio_envio_tlf1').val($('#direccio_facturacio_tlf1').val());
            $('#direccio_envio_tlf2').val($('#direccio_facturacio_tlf2').val());
            $('#direccio_envio_nif').val($('#direccio_facturacio_nif').val());
            $('#direccio_envio_email').val($('#direccio_facturacio_email').val());
        }
        else
        {
            $("#direccio_envio").slideDown("slow");
        }

    });


    /*
    FANCYBOX
    */

    $(".fancybox").fancybox();

});


$(function(){

    //Cart crear cuenta  primer pas checkout
  $('#registrar_cuenta').on("change",function(){
    $passwd = $('label[for="contrasenya"]').parent();
    if($(this).is(':checked')){
        $passwd.removeClass("hide");
        $passwd.find("input").attr("required",true);
    }else{
        $passwd.addClass("hide");
        $passwd.find("input").attr("required",false);
    }
  });

    //Cart shipping / payment methods
    $('#checkout-content').on('click', '.shipping-methods .box, .payment-methods .box', function(e) {
        var radio = $(this).find(':radio');
        radio.prop('checked', true);
        if($(this).find("input[name='transport']").length>0){
            var preu_shipping = $(this).find("input[name='transport']").data("preu");
            var preu_total = $(this).find("input[name='transport']").data("preu-total");
            $('.cart-details .shipping').text(preu_shipping);
            $('.cart-details .total').text(preu_total);
        }
    });

    // UCP
    if($('.ucp').length>0) {
        $('#myTab a').click(function (e) {
          e.preventDefault();
          $(this).tab('show');
        });

        if(window.location.hash) {
          var hash = window.location.hash;
          $("a[href=" + hash + "]").tab('show');
        }
    }

});


//Social share
function share(url) {
    var winWidth = 520;
    var winHeight = 350;
    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);
    window.open(url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}
function fbshare(url,title,descp,image){
    url = encodeURIComponent(url);
    title = encodeURIComponent(title);
    descp = encodeURIComponent(descp);
    image = encodeURIComponent(image);
    url = 'http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descp + '&p[url]=' + url + '&p[images][0]=' + image;
    share(url);
}
function twshare(url,text){
    url = encodeURIComponent(url);
    text = encodeURIComponent(text);
    url = 'https://twitter.com/intent/tweet?url=' + url + '&via=PopPlaces_es&related=PopPlaces_es&text=' + text;
    share(url);
}


function activateWishlist() {

    $(".toggle-wishlist").unbind("click");

    $('.toggle-wishlist').tooltip();

    $('.toggle-wishlist').click(function (e) {
        e.preventDefault();
        var codi = $(this).data('codi'),
            action = 'afegir',
            tooltip_title = $(this).data('title-eliminar');

        if ($(this).hasClass('active')) {
            action = 'eliminar';
            tooltip_title = $(this).data('title-afegir');
        }

        $(this).tooltip('destroy');
        $(this).attr('title', tooltip_title);

        $(this).toggleClass('active');

        $(this).tooltip('hide')
            .attr('data-original-title', tooltip_title)
            .tooltip('fixTitle')
            .tooltip('show');

        $.ajax({
            type: 'POST',
            url: '/wishlist/',
            data: {
                action: action,
                codi: codi
            }
        });
    });
}

var Offers = (function () {

  var $container;

    // Metodes publics
    var init = function() {
      $container = $('.product-list .row');

      makeIsotope();
    };

      function makeIsotope() {
        $container.imagesLoaded( function() {
           $container.isotope({
              itemSelector: '.item',
              layoutMode: 'masonry'
            });
        });
      }


      return {
        init: init,
        container: $container
      };

    }());




var OfflineBrowse = (function () {

    var currentArt = 0;
    var codis = [];

    // Metodes publics
    var init = function () {
        bindEvents();
        getProductesAjax();
    };

    // Metodes privats
    function bindEvents() {
        $(document).on('change', 'select[name=ubicacion],select[name=autor],select[name=price]', function () {
            getProductesAjax();
        });

        $('#container-offline-browse').disableSelection();

        document.addEventListener('swiped-left', function(e) {
            nextArt();
        });

        document.addEventListener('swiped-right', function(e) {
            prevArt();
        });

        $(document).keyup(function(e) {
            if (e.keyCode == 39) {
                nextArt();
            }
            if (e.keyCode == 37) {
                prevArt();
            }
        });

        $('.nextArt').click(function(e) {
            e.preventDefault();
            nextArt();
        });

        $('.prevArt').click(function(e) {
            e.preventDefault();
            prevArt();
        });
    }

    function nextArt() {
        currentArt++;
        if (currentArt >= codis.length) {
            currentArt = 0;
        }
        loadArt();
    }

    function prevArt() {
        currentArt--;
        if (currentArt < 0) {
            currentArt = codis.length - 1;
        }
        loadArt();
    }

    function loadArt() {
        $('#ajax-loader').show();
        $('#container-offline-browse').hide();
        var codi = codis[currentArt];

        if (codi == undefined) {
            $('#container-offline-browse').html('No results');
            return true;
        }

        $.ajax({
            type: 'GET',
            url: '/auxiliar/get-offline-product-info.php',
            data: {
                codi: codi,
            }
        }).done(function (html) {
            $('#container-offline-browse').html(html);
            $('#ajax-loader').hide();
            $('#container-offline-browse').show();
        });
    }

    function getProductesAjax() {
        $('#ajax-loader').show();
        $('#container-offline-browse').hide();
        $.ajax({
            type: 'GET',
            url: '/auxiliar/offline-browse.php',
            data: {
                ubicacion: $('select[name=ubicacion]').val(),
                autor: $('select[name=autor]').val(),
                price: $('select[name=price]').val(),
            },
            dataType: 'json'
        }).done(function (result) {
            codis = result;
            currentArt = 0;
            loadArt();
        });
    }

    return {
        init: init
    };

}());

/*
Descaregar factura/Albara
*/

var OrderDetail = function () {

 function descarregarAlbara($btn,comandaid){
    $btn.hide();
    $btn.parent().append("<img src='/administrator/assets/loading.gif' class='downloading-albara_"+comandaid+"'/>");
     $.ajax({
        url: '/albara-pdf/'+comandaid+"/",
        type: 'POST',
        success: function() {
            window.location = '/albara-pdf/'+comandaid+"/";
            setTimeout(function(){
                $('.downloading-albara_'+comandaid).remove();
                $btn.show();
            }, 1000);
        }
    });
  }

  function descarregarFactura($btn,facturaid){
    $btn.hide();
    $btn.parent().append("<img src='/administrator/assets/loading.gif' class='downloading-factura_"+facturaid+"'/>");
     $.ajax({
        url: '/invoice-pdf/'+facturaid+"/",
        type: 'POST',
        success: function() {
            window.location = '/invoice-pdf/'+facturaid+"/";
            setTimeout(function(){
                $('.downloading-factura_'+facturaid).remove();
                $btn.show();
            }, 1000);
        }
    });
  }

  function descarregarXecRegal($btn,codi_xec){
    $btn.hide();
    $btn.parent().append("<img src='/administrator/assets/loading.gif' class='downloading-xec_"+codi_xec+"'/>");
     $.ajax({
        url: '/xec-pdf/'+codi_xec+"/",
        type: 'POST',
        success: function() {
            window.location = '/xec-pdf/'+codi_xec+"/";
            setTimeout(function(){
                $('.downloading-xec_'+codi_xec).remove();
                $btn.show();
            }, 1000);
        }
    });
  }

  function events(){

    $(document).on('click','#download-albara',function(e){
      e.preventDefault();
       descarregarAlbara($(this),$(this).data('comandaid'));
    })

    $(document).on('click','#download-factura',function(e){
      e.preventDefault();
       descarregarFactura($(this),$(this).data('facturaid'));
    })

    $(document).on('click','.download-xec-regal',function(e){
      e.preventDefault();
       descarregarXecRegal($(this),$(this).data('xec-regal'));
    })

  }


  return {
    init: function () {
      events();
    }
  };
}();

var Portada = (function () {

  var $container;
  var $container_mosaic_mobil;

    // Metodes publics
    var init = function() {
      $container = $('.related .masonry');
      makeIsotope();
      if($('.mosaic').hasClass("mobil")){
        initMobil();
      }
        activateWishlist();
    };

    var initMobil = function(){
      $container_mosaic_mobil = $('.mosaic .row');
      makeIsotopeMobil();
    };

    function makeIsotope() {
       $container.imagesLoaded( function() {
           $container.isotope({
              itemSelector: '.item',
              layoutMode: 'masonry'
            });

           General.checkLargeImages();

        });
    }

    function makeIsotopeMobil() {
       $container_mosaic_mobil.imagesLoaded( function() {
           $container_mosaic_mobil.isotope({
              itemSelector: '.mosaic-col',
              layoutMode: 'masonry'
            });

           General.checkLargeImages();

        });
    }

    return {
      init: init,
      container: $container
    };

  }());


var ProductVal = (function () {

  var $select_import;
  var $input_import;

  var init = function() {
    $select_import = $('.form_add_to_cart select[name="import"]');
    $input_import = $('.form_add_to_cart input[name="custom_import"]');
    bindEvents();

    setInitialValue();
  };

  function setInitialValue(){
    $input_import.val($select_import.val());
  }

  // Metodes privats
  function bindEvents() {

    //Al canviar el marc via selector, canviem el marc seleccionat 'graficament'
    $select_import.on('change',function(event){
     if($(this).val()==0){
      $input_import.parent().removeClass("hide");
     }else{
      $input_import.parent().addClass("hide");
      $input_import.val($(this).val());
     }

    });

  }

  return {
    init: init
  };


 })();

var Product = (function () {

  var $image;
  var choice_text;
  var $marc_select;
  var te_marc;

  var init = function() {
    $image = $('.product-image');
    te_marc = false;
    if($('.fake_select').length>0){
      te_marc = true;
      $marc_select = $('.form_add_to_cart select[name="marc_codi"]');
    }

    vertAlign();
    bindEvents();
    choice_text = $('.fs-choice').text();
    initializeAmbience();
    makeIsotope();
    activateWishlist();

  };

  function makeIsotope() {
    var $container = $('.related .row');
    $container.imagesLoaded( function() {
      $container.isotope({
        itemSelector: '.item',
        layoutMode: 'masonry'
      });
    });
  }

  // Metodes privats
  function bindEvents() {

    $(document).on('click','.product-thumbnails a',function(e){
      $('.product-image a').attr('href',$(this).data('src-original'));
      $('.product-image a img').attr('src',$(this).data('src-medium'));
      $('.product-image a img').attr('alt',$(this).data('alt-text'));
    });

    $(document).on('click','.fake_select',function(event){
      $('#frame-selector').fadeIn();
      // $('#frame-selector').addClass('visible');
      $('body').toggleClass('overflow-hidden');
    })

    // Obrir selector de marc
    $(document).on('click', '.select-frame', function(event){
      event.preventDefault();
      $('#frame-selector').fadeIn();
      // $('#frame-selector').addClass('visible');
      $('body').toggleClass('overflow-hidden');
    });

    // Provisional per tancar selector de marc
    $(document).on('click', '#frame-selector .fs-close', function(event){
      if (event.target == this) {
        event.preventDefault();
        $('#frame-selector').fadeOut();
        $('body').toggleClass('overflow-hidden');
      }
    });

    // Canviar de marc
    $(document).on('click', '.fs-frame-item', function(event){
      setMarc($(this));
      $marc_select.val($(this).data("marc"));
    });

    function setMarc($elem){
      $('.fs-frame-item').removeClass('active');
      if($elem.attr("data-preu")){
        var preu_marc = $elem.data("preu");
        $('.product-data .marc_price').text("+"+preu_marc).removeClass("hide");

        //Reset
        $('#ambiance-view .part_marc').addClass("invisible");
        $('#ambiance-view .marc_cont').attr("style","");
        $('#ambiance-view .part_marc').attr("style","");

        $marc_cont = $('#ambiance-view .marc_cont');

        //Posar marc ambient
        if(te_marc){
          var $marc_opt = $marc_select.find('option[value="' + $elem.data("marc") + '"]');
          var marc_material_id = $marc_opt.data("material");
          var marc_gruix = $marc_opt.data("gruix");
          var marc_es_passepartout = $marc_opt.data("passepartout");
          var marc_te_dist = $marc_opt.data("dist");
          var marc_amplada = $marc_opt.data("x");
          var marc_alsada = $marc_opt.data("y");
          var marc_assets_path = "/assets/img/dist/marcs/"+marc_material_id+"/";

          var escala = $marc_cont.data("escala");
          //CM -> PX
          marc_alsada = escala * marc_alsada;
          marc_amplada = escala * marc_amplada;
          marc_gruix = escala * marc_gruix;
          marc_gruix = Math.ceil(marc_gruix);
          marc_alsada+=(marc_gruix*2);
          marc_amplada+=(marc_gruix*2);

          //Set width/height marc i posicionar
          $marc_cont.css({
            "height": marc_alsada+"px",
            "width": marc_amplada+"px",
            "margin-top": -(marc_alsada/2)+"px",
            "margin-left": -(marc_amplada/2)+"px"
          });
          if(marc_es_passepartout){
            $marc_cont.addClass("passepartout");
          }else{
            $marc_cont.removeClass("passepartout");
          }

          //Get parts
          var $marc_part_left = $('#ambiance-view .part_marc.left');
          var $marc_part_top = $('#ambiance-view .part_marc.top');
          var $marc_part_right = $('#ambiance-view .part_marc.right');
          var $marc_part_bottom = $('#ambiance-view .part_marc.bottom');

          //Set assets
          $marc_part_left.attr("src",marc_assets_path+"left.png?v=1.2");
          $marc_part_top.attr("src",marc_assets_path+"top.png?v=1.2");
          $marc_part_right.attr("src",marc_assets_path+"right.png?v=1.2");
          $marc_part_bottom.attr("src",marc_assets_path+"bottom.png?v=1.2");

          //Set height parts left/right
          $marc_part_left.css("height",marc_alsada+"px");
          $marc_part_right.css("height",marc_alsada+"px");

          //Set width parts top/bottom
          $marc_part_top.css("width",marc_amplada+"px");
          $marc_part_bottom.css("width",marc_amplada+"px");

          //Set gruix marc
          $marc_part_left.css("width",marc_gruix+"px");
          $marc_part_right.css("width",marc_gruix+"px");
          $marc_part_top.css("height",marc_gruix+"px");
          $marc_part_bottom.css("height",marc_gruix+"px");

          //Fem visible el marc
          $('#ambiance-view .part_marc').removeClass("invisible");
        }

      }else{
        $('#ambiance-view .part_marc').addClass("invisible");
        $('.product-data .marc_price').text("").addClass("hide");
      }

      $('.fs-choice').remove();
      $elem.addClass('active');
      $elem.append('<div class="fs-choice">'+choice_text+'</div>');
    }

    // Obrir selector ambiance DETALL
    $(document).on('click', '.select-ambiance-detail', function(event){
      event.preventDefault();
      AmbianceDetail.openEscene();
    });

    // Obrir selector ambiance DETALL SMALL
    $(document).on('click', '.select-ambiance-detail-small', function(event){
      event.preventDefault();
      AmbianceDetailSmall.openEscene();
    });


    // Obrir selector ambiance FULL WIDTH
    $(document).on('click', '.select-ambiance', function(event){
      event.preventDefault();
      AmbianceFullWidth.openEscene();
    });

    if(te_marc){
      //Al canviar el marc via selector, canviem el marc seleccionat 'graficament'
      $marc_select.on('change',function(event){
       var marc = $(this).val();
       var $elem = $('.fs-frame-item:first');
       if(marc!=0){
        $elem = $('.fs-frame-item[data-marc="'+marc+'"]');
       }
       setMarc($elem);
      });

      $('.passepartout-select .btn').on("click",function(){
        $('.passepartout-select .btn').removeClass("active");
        $(this).addClass("active");
        showFramesByPasspartout();
      });
    }

    function showFramesByPasspartout(){
      //Amagar tab en cas que no n'hi hagi amb/sense passepartout
      if($('.fs-frame-item[data-passepartout="false"]').length==0){
        $('.passepartout-select button[data-passepartout="0"]').hide();
        $('.passepartout-select button[data-passepartout="1"]').click();
      }
      if($('.fs-frame-item[data-passepartout="true"]').length==0){
        $('.passepartout-select button[data-passepartout="1"]').hide();
        $('.passepartout-select button[data-passepartout="0"]').hide(); //Si només hi ha marcs SENSE PASSEPARTOUT, com que és l'habitual no mostrar-ho
      }

      //Amagar/mostrar marcs en base passepartout
      var passepartout = $('.passepartout-select .btn.active').data("passepartout");
      if(passepartout==1){
        $('.fs-frame-item[data-passepartout="false"]').addClass("hide");
        $('.fs-frame-item[data-passepartout="true"]').removeClass("hide");
      }else{
        $('.fs-frame-item[data-passepartout="true"]').addClass("hide");
        $('.fs-frame-item[data-passepartout="false"]').removeClass("hide");
      }

      $('.fs-framegroup').each(function(){
        if ($(this).find('.fs-frame-item:not(.hide)').length==0) {
          $(this).hide();
        }else{
          $(this).show();
        }
      })
    }
    showFramesByPasspartout();

  } //Fi events

  function initializeAmbience(){
    if($('.select-ambiance').length==1){
      AmbianceFullWidth.init();
    }
    if($('.select-ambiance-detail').length==1){
      AmbianceDetail.init();
    }
    if($('.select-ambiance-detail-small').length==1){
      AmbianceDetailSmall.init();
    }
  }

  function vertAlign() {
    $('.verticalAlign').each(function(){
      var height = $(this).height();
      var parentHeight = $(this).parent().height();

      $(this).css({
        'margin-top':(parentHeight-height)/2+'px'
      });
    });
  }


  return {
    init: init
  };

})();





/**
 * Ambiance FULL WIDTH
 */
var AmbianceFullWidth = (function () {

  // Metodes publics
  var init = function() {
      bindEvents();
  };

  var openEscene = function(){

    $("html, body").animate({ scrollTop: 0 }, 400, function(){
      $('body').addClass('overflow-hidden');
      $('#ambiance-view').fadeIn("slow", function(){
        $('.av-item').animate({opacity: 1}, 400, function(){
            posicionarTerra();
        });
      });
    });
    setShadow();

  };

  // Metodes privats
  function bindEvents() {

    // Tancar selector ambiance
    $(document).on('click', '.av-close', function(event){
      event.preventDefault();
      $('.av-item').css('opacity', 0);
      $('#ambiance-view').hide();
      $('body').removeClass('overflow-hidden');
    });

     $(window).resize(function(){
      posicionarTerra();
    })

  }

  function posicionarTerra(){
    var distance = $('.obra').offset().top + $('.obra').height() -  $('#bg_ambiance').offset().top;

    if(distance>(-30)){
      var min_height = $('.obra').offset().top + $('.obra').height() + 250;

      $('#ambiance-view').css({
        'min-height': min_height+"px"
      });
    }
  }

  function setShadow(){
    $('.marc_cont').removeClass("shadow");
    $('.obra').removeClass("shadow");

    if($('#ambiance-view .part_marc').hasClass("invisible")){
      $('.obra').addClass("shadow");
    }else{
      $('.marc_cont').addClass("shadow");
    }
  }

  return {
    init: init,
    openEscene: openEscene
  };

}());





/**
 * Ambiance DETAIL
 */
var AmbianceDetail = (function () {

  var escala = 0;

  // Metodes publics
  var init = function() {
    escala = $('#ambiance-view .marc_cont').data("escala");
  };

  var openEscene = function(){
    var html_content = "<div id='cont-ambience-detail' class='invisible'>"+$('.av-item').html()+"<img src='/assets/img/dist/ambiance/detail-2-5.jpg'/></div>";

    $.fancybox({
      'content': html_content,
      'scrolling': 'no',
      'padding': 10,
      'beforeClose': function() {   },
    });

    setTimeout(function(){
      posicionarTop();
      posicionarLeft();
      $('#cont-ambience-detail').removeClass("invisible");
    }, 500);

    setShadow();
  };

  function setShadow(){
    $('.marc_cont').removeClass("shadow");
    $('.obra').removeClass("shadow");

    if($('#ambiance-view .part_marc').hasClass("invisible")){
      $('.obra').addClass("shadow");
    }else{
      $('.marc_cont').addClass("shadow");
    }
  }

  function posicionarTop(){
    //posicionar top
    var h_moble_gerro = 124; //cm
    var dist_obra_gerro = 30; //cm

    h_moble_gerro = h_moble_gerro*escala;
    dist_obra_gerro = dist_obra_gerro*escala;

    var obra_dist_terra = h_moble_gerro + dist_obra_gerro;

    var h_cont = $('#cont-ambience-detail').height();
    var h_obra = Math.max($('#cont-ambience-detail .obra').height(),$('#cont-ambience-detail .marc_cont').height());
    var current_obra_dist_terra = (h_cont/2)-(h_obra/2);
    var marge = obra_dist_terra - current_obra_dist_terra;

    var mt_marc = $('#cont-ambience-detail .marc_cont').css('marginTop').replace('px','');
    var mt_obra = $('#cont-ambience-detail .obra').css('marginTop').replace('px','');

    var aux = Math.max(Math.abs(mt_marc),Math.abs(mt_obra)) + Math.abs(marge);
    //console.log(aux);

    //Evitar que quedi massa amunt.
    //console.log(aux);
    //console.log((h_cont/2));
    if(aux>(h_cont/2)){
      aux = aux - (h_cont/2);
      marge = marge-aux; //Marc top = 0
      marge = marge - 30;
      //console.log("Up limit");
    }

    //Posicionar marc i obra
    mt_marc-=marge;
    $('#cont-ambience-detail .marc_cont').css('marginTop',mt_marc+'px');

    mt_obra-=marge;
    $('#cont-ambience-detail .obra').css('marginTop',mt_obra+'px');
  }

  function posicionarLeft(){
    var dist = 187; //Distancia amb pixels fins la pota
    var w_cont = $('#cont-ambience-detail').width();
    var centre_cont = w_cont/2;

    var ml_marc = parseFloat($('#cont-ambience-detail .marc_cont').css('marginLeft').replace('px',''));
    var ml_obra = parseFloat($('#cont-ambience-detail .obra').css('marginLeft').replace('px',''));

    var dist_marc = centre_cont-Math.abs(ml_marc);
    var dist_obra = centre_cont-Math.abs(ml_obra);
    var max_dist = Math.min(dist_marc,dist_obra);

    var marge = dist - max_dist;

    //Posicionar marc i obra
    ml_marc+=marge;
    $('#cont-ambience-detail .marc_cont').css('marginLeft',ml_marc+'px');
    ml_obra+=marge;
    $('#cont-ambience-detail .obra').css('marginLeft',ml_obra+'px');
    checkLeftPosition();
  }

  function checkLeftPosition(){
    var w_cont = $('#cont-ambience-detail').width();
    var centre_cont = w_cont/2;
    //LEFT
    var ml_marc = parseFloat($('#cont-ambience-detail .marc_cont').css('marginLeft').replace('px',''));
    var ml_obra = parseFloat($('#cont-ambience-detail .obra').css('marginLeft').replace('px',''));

    var dist_marc = centre_cont-Math.abs(ml_marc);
    var dist_obra = centre_cont-Math.abs(ml_obra);
    var dist_to_obra = Math.min(dist_marc,dist_obra);
    console.log(dist_to_obra);

    //WIDTH
    var w_marc = $('#cont-ambience-detail .marc_cont').width();
    var w_obra = $('#cont-ambience-detail .obra').width();
    var max_w = Math.max(w_obra,w_marc);

    if(max_w+dist_to_obra > w_cont - 20){
      console.log("limit right");
      var marge = max_w+dist_to_obra - w_cont + 20;

      //Posicionar marc i obra
      ml_marc-=marge;
      $('#cont-ambience-detail .marc_cont').css('marginLeft',ml_marc+'px');

      ml_obra-=marge;
      $('#cont-ambience-detail .obra').css('marginLeft',ml_obra+'px');

    }
  }

  return {
    init: init,
    openEscene: openEscene
  };

}());



/**
 * Ambiance DETAIL
 */
var AmbianceDetailSmall = (function () {

  var escala = 0;

  // Metodes publics
  var init = function() {
    escala = $('#ambiance-view .marc_cont').data("escala");
  };

  var openEscene = function(){
    var html_content = "<div id='cont-ambience-detail' class='invisible'>"+$('.av-item').html()+"<img src='/assets/img/dist/ambiance/detail-small.jpg'/></div>";

    $.fancybox({
      'content': html_content,
      'scrolling': 'no',
      'padding': 10,
      'beforeClose': function() {   },
    });

    setTimeout(function(){
      posicionarTop();
      posicionarLeft();
      $('#cont-ambience-detail').removeClass("invisible");
    }, 500);

    setShadow();
  };

  function setShadow(){
    $('.marc_cont').removeClass("shadow");
    $('.obra').removeClass("shadow");

    if($('#ambiance-view .part_marc').hasClass("invisible")){
      $('.obra').addClass("shadow");
    }else{
      $('.marc_cont').addClass("shadow");
    }
  }

  function posicionarTop(){
    //posicionar top
    var h_moble_gerro = 124; //cm
    var dist_obra_gerro = 30; //cm

    h_moble_gerro = h_moble_gerro*escala;
    dist_obra_gerro = dist_obra_gerro*escala;

    var obra_dist_terra = h_moble_gerro + dist_obra_gerro;

    var h_cont = $('#cont-ambience-detail').height();
    var h_obra = Math.max($('#cont-ambience-detail .obra').height(),$('#cont-ambience-detail .marc_cont').height());
    var current_obra_dist_terra = (h_cont/2)-(h_obra/2);
    var marge = obra_dist_terra - current_obra_dist_terra;

    var mt_marc = $('#cont-ambience-detail .marc_cont').css('marginTop').replace('px','');
    var mt_obra = $('#cont-ambience-detail .obra').css('marginTop').replace('px','');

    var aux = Math.max(Math.abs(mt_marc),Math.abs(mt_obra)) + Math.abs(marge);
    //console.log(aux);

    //Evitar que quedi massa amunt.
    //console.log(aux);
    //console.log((h_cont/2));
    if(aux>(h_cont/2)){
      aux = aux - (h_cont/2);
      marge = marge-aux; //Marc top = 0
      marge = marge - 30;
      //console.log("Up limit");
    }

    //Posicionar marc i obra
    mt_marc-=marge;
    $('#cont-ambience-detail .marc_cont').css('marginTop',mt_marc+'px');

    mt_obra-=marge;
    $('#cont-ambience-detail .obra').css('marginTop',mt_obra+'px');
  }

  function posicionarLeft(){
    var dist = 200; //Distancia amb pixels fins la pota
    var w_cont = $('#cont-ambience-detail').width();
    var centre_cont = w_cont/2;

    var ml_marc = parseFloat($('#cont-ambience-detail .marc_cont').css('marginLeft').replace('px',''));
    var ml_obra = parseFloat($('#cont-ambience-detail .obra').css('marginLeft').replace('px',''));

    var dist_marc = centre_cont-Math.abs(ml_marc);
    var dist_obra = centre_cont-Math.abs(ml_obra);
    var max_dist = Math.min(dist_marc,dist_obra);

    var marge = dist - max_dist;

    //Posicionar marc i obra
    ml_marc+=marge;
    $('#cont-ambience-detail .marc_cont').css('marginLeft',ml_marc+'px');
    ml_obra+=marge;
    $('#cont-ambience-detail .obra').css('marginLeft',ml_obra+'px');
    checkLeftPosition();
  }

  function checkLeftPosition(){
    var w_cont = $('#cont-ambience-detail').width();
    var centre_cont = w_cont/2;
    //LEFT
    var ml_marc = parseFloat($('#cont-ambience-detail .marc_cont').css('marginLeft').replace('px',''));
    var ml_obra = parseFloat($('#cont-ambience-detail .obra').css('marginLeft').replace('px',''));

    var dist_marc = centre_cont-Math.abs(ml_marc);
    var dist_obra = centre_cont-Math.abs(ml_obra);
    var dist_to_obra = Math.min(dist_marc,dist_obra);
    console.log(dist_to_obra);

    //WIDTH
    var w_marc = $('#cont-ambience-detail .marc_cont').width();
    var w_obra = $('#cont-ambience-detail .obra').width();
    var max_w = Math.max(w_obra,w_marc);

    if(max_w+dist_to_obra > w_cont - 20){
      console.log("limit right");
      var marge = max_w+dist_to_obra - w_cont + 20;

      //Posicionar marc i obra
      ml_marc-=marge;
      $('#cont-ambience-detail .marc_cont').css('marginLeft',ml_marc+'px');

      ml_obra-=marge;
      $('#cont-ambience-detail .obra').css('marginLeft',ml_obra+'px');

    }
  }

  return {
    init: init,
    openEscene: openEscene
  };

}());

var Stores = (function () {

  var $container;


  // Metodes publics
  var init = function() {
    $container = $('.stores-list');

    makeIsotope();
  };


  function makeIsotope() {
    $container.imagesLoaded( function() {
      $container.isotope({
        itemSelector: '.item',
        layoutMode: 'masonry'
      });
    });
  }

  return {
    init: init,
    container: $container
  };

}());



